/* Stellan theme JS. Vanilla, no dependencies. */
(function () {
  "use strict";
  var T = window.theme || (window.theme = {});
  var R = T.routes || {};
  var S = T.strings || {};

  /* ---------- Money ---------- */
  T.formatMoney = function (cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    format = format || T.moneyFormat || "${{amount}}";
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ","; ds = ds || ".";
      if (isNaN(n) || n == null) return "0";
      n = (n / 100).toFixed(dec);
      var p = n.split("."), d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + th);
      return d + (p[1] ? ds + p[1] : "");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case "amount_no_decimals": return fmt(cents, 0);
        case "amount_with_comma_separator": return fmt(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmt(cents, 2, "'");
        default: return fmt(cents, 2);
      }
    });
  };

  /* ---------- Bundle maths (same rules as the live site) ---------- */
  T.upgradeMath = function (curCents, curCount, nextCents, nextCount) {
    return { more: nextCents - curCents, save: Math.round((curCents / curCount) * nextCount - nextCents) };
  };
  T.variantKey = function (colours) {
    var s = 0, g = 0;
    colours.forEach(function (c) { c === "gold" ? g++ : s++; });
    return colours.length === 1 ? (s ? "Silver" : "Gold") : s + " Silver / " + g + " Gold";
  };
  T.summarize = function (colours) {
    var s = colours.filter(function (c) { return c !== "gold"; }).length, g = colours.length - s, out = [];
    if (s) out.push(s + " " + (S.silver || "Silver"));
    if (g) out.push(g + " " + (S.gold || "Gold"));
    return out.join(", ");
  };
  T.parseKey = function (title) {
    var m = /^(\d+)\s+Silver\s*\/\s*(\d+)\s+Gold$/i.exec(title || "");
    if (m) return { silver: +m[1], gold: +m[2], count: +m[1] + +m[2] };
    if (/^silver$/i.test(title)) return { silver: 1, gold: 0, count: 1 };
    if (/^gold$/i.test(title)) return { silver: 0, gold: 1, count: 1 };
    return null;
  };

  /* ---------- Cart API ---------- */
  function json(url, body) {
    return fetch(url, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) { var e = new Error(d.description || d.message || "Error"); e.data = d; throw e; }
        return d;
      });
    });
  }
  T.cart = {
    get: function () { return json(R.cart + ".js"); },
    add: function (id, qty) { return mutate(function (cart, catalog, colours) {
      var v;
      Object.keys(catalog).some(function (k) { v = catalog[k].variants.find(function (x) { return String(x.id) === String(id); }); return !!v; });
      if (!v) throw new Error("This product is not configured for bracelet bundle pricing.");
      var c = window.StellanBundlePricing.parse(v.title);
      if (!c) throw new Error("Unrecognised bracelet colour mix.");
      colours.silver += c.silver * (qty || 1); colours.gold += c.gold * (qty || 1);
    }); },
    change: function (key, qty) { return mutate(function (cart, catalog, colours) {
      var item = cart.items.find(function (x) { return x.key === key; });
      if (!item) throw new Error("Cart changed. Please try again.");
      if (!window.StellanBundlePricing.identify(item, catalog)) throw new Error("Not a bracelet line.");
      var c = window.StellanBundlePricing.parse(item.variant_title), current = (c.silver + c.gold) * item.quantity;
      var delta = qty - current;
      // Increment repeats the first colour on this line; decrement removes Gold first.
      if (delta > 0) colours[c.silver ? "silver" : "gold"] += delta;
      else {
        var remove = -delta, g = Math.min(remove, c.gold * item.quantity);
        colours.gold -= g; colours.silver -= remove - g;
      }
    }); }
  };
  var queue = Promise.resolve(), catalogCache;
  function catalog() {
    var el = document.querySelector("[data-bundle-catalog]");
    if (!el) return Promise.reject(new Error("Bracelet bundle products are not configured."));
    var data = JSON.parse(el.textContent);
    if (catalogCache) return Promise.resolve(catalogCache);
    return Promise.all(Object.keys(data).map(function (id) {
      if (!data[id].handle) throw new Error("Select all four bracelet products in the Cart drawer settings.");
      return json(R.root + "products/" + data[id].handle + ".js").then(function (p) {
        data[id].variants = p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, available: v.available }; });
      });
    })).then(function () { catalogCache = data; return data; });
  }
  function mutate(edit) {
    var run = queue.catch(function () {}).then(function () {
      document.querySelectorAll("[data-qty], [name=checkout]").forEach(function (b) { b.disabled = true; });
      return Promise.all([T.cart.get(), catalog()]).then(function (values) {
        var cart = values[0], products = values[1], P = window.StellanBundlePricing;
        var colours = P.totals(cart, products);
        if (edit) edit(cart, products, colours);
        var planned = P.plan(colours, products), desired = {}, updates = {};
        planned.lines.forEach(function (line) { desired[line.id] = (desired[line.id] || 0) + line.quantity; });
        cart.items.forEach(function (line) {
          if (!P.identify(line, products)) return;
          if (line.selling_plan_allocation || (line.properties && Object.keys(line.properties).length)) throw new Error("Customised bracelet lines cannot be automatically regrouped.");
          updates[line.key] = desired[line.variant_id] || 0;
          delete desired[line.variant_id];
        });
        Object.keys(desired).forEach(function (id) { updates[id] = desired[id]; });
        var unchanged = !Object.keys(desired).length && cart.items.every(function (line) { return updates[line.key] === undefined || updates[line.key] === line.quantity; });
        return (unchanged ? Promise.resolve(cart) : json(R.cart + "/update.js", { updates: updates })).then(function (result) {
          var actual = P.totals(result, products);
          if (actual.silver !== colours.silver || actual.gold !== colours.gold) throw new Error("Shopify could not fulfil this bracelet mix. Please review your cart before checkout.");
          return cartChanged(result).then(function () { return result; });
        });
      }).finally(function () { document.querySelectorAll("[data-qty], [name=checkout]").forEach(function (b) { b.disabled = false; }); });
    });
    queue = run; return run;
  }
  T.normalizeCart = function () { return mutate(); };
  T.addBracelets = function (colours) {
    return mutate(function (cart, products, counts) {
      colours.forEach(function (colour) { counts[colour === "gold" ? "gold" : "silver"]++; });
    });
  };
  function cartChanged(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      var n = cart ? T.braceletCount(cart) : 0;
      el.textContent = n; el.hidden = n === 0;
    });
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    return Promise.all(Array.prototype.map.call(document.querySelectorAll("cart-drawer, [data-cart-page]"), function (el) {
      if (el.matches("cart-drawer")) return el.render();
      return fetch(R.cart + "?section_id=" + el.getAttribute("data-section-id")).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-page]");
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    }));
  }
  T.refreshCart = function () { return T.cart.get().then(function (c) { return cartChanged(c).then(function () { return c; }); }); };
  T.braceletCount = function (cart) {
    return cart.items.reduce(function (n, it) {
      var k = T.parseKey(it.variant_title);
      return n + (k ? k.count : 1) * it.quantity;
    }, 0);
  };
  T.addToCart = function (variantId, qty) {
    return T.cart.add(variantId, qty).then(function (c) {
      var d = document.querySelector("cart-drawer");
      if (d) d.open();
      return c;
    });
  };

  /* ---------- Reveal ---------- */
  function initReveal() {
    if (!("IntersectionObserver" in window) || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.classList.add("reveal"); io.observe(el);
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector(".gallery__track");
    if (!track) return;
    var slides = track.children, dots = root.querySelectorAll(".gallery__dot"), thumbs = root.querySelectorAll(".gallery__thumb");
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { var n = slides.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" }); }
    function mark() {
      var i = idx();
      dots.forEach(function (d, j) { d.classList.toggle("is-active", i === j); });
      thumbs.forEach(function (t, j) { t.setAttribute("aria-current", i === j ? "true" : "false"); });
    }
    track.addEventListener("scroll", function () { requestAnimationFrame(mark); }, { passive: true });
    var p = root.querySelector(".gallery__arrow--prev"), n = root.querySelector(".gallery__arrow--next");
    if (p) p.addEventListener("click", function () { go(idx() - 1); });
    if (n) n.addEventListener("click", function () { go(idx() + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener("click", function () { go(j); }); });
    mark();
  }

  /* ---------- Offer ---------- */
  function initOffer(root) {
    var dataEl = root.querySelector("[data-offer-json]");
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var state = { selected: data.defaultBundle };
    var btn = root.querySelector("[data-add]"), err = root.querySelector("[data-offer-error]");
    var bundles = root.querySelectorAll("[data-bundle]");

    function pick(id) {
      var el = root.querySelector('[data-bundle="' + id + '"]');
      if (!el) return [];
      return Array.prototype.map.call(el.querySelectorAll("select[data-colour]"), function (s) { return s.value; });
    }
    function variant(id) {
      var b = data.bundles[id];
      if (!b) return null;
      var el = root.querySelector('[data-bundle="' + id + '"]');
      var vs = el && el.querySelector("[data-variant-select]");
      if (vs) return b.variants.filter(function (v) { return v.title === vs.value; })[0] || null;
      var cols = pick(id);
      if (!cols.length) return b.variants[0] || null;
      var key = T.variantKey(cols);
      return b.variants.filter(function (v) { return v.title === key; })[0] || null;
    }
    function render() {
      bundles.forEach(function (el) {
        var on = el.getAttribute("data-bundle") === state.selected;
        el.classList.toggle("is-active", on);
        var r = el.querySelector("[role=radio]");
        if (r) r.setAttribute("aria-checked", on ? "true" : "false");
        el.hidden = el.hasAttribute("data-single") && !on;
        var setEl = el.querySelector("[data-your-set]");
        if (setEl) setEl.textContent = T.summarize(pick(el.getAttribute("data-bundle")));
        el.querySelectorAll("select[data-colour]").forEach(function (s) {
          var img = s.parentNode.querySelector("img");
          if (img) { img.src = data.swatches[s.value].src; img.alt = data.swatches[s.value].alt; }
        });
      });
      var link = root.querySelector("[data-single-link]");
      if (link) link.hidden = state.selected === "single";
      var v = variant(state.selected);
      var ok = v && v.available;
      btn.disabled = !ok;
      btn.textContent = v ? data.ctaPrefix + " - " + T.formatMoney(v.price) : data.ctaPrefix;
      err.hidden = !!ok;
      err.textContent = v && !v.available ? S.soldOut : S.unavailable;
      var sku = root.querySelector("[data-sku]");
      if (sku) sku.textContent = v && v.sku ? v.sku : "";
      document.dispatchEvent(new CustomEvent("offer:change", { detail: { bundle: state.selected, variant: v } }));
    }
    bundles.forEach(function (el) {
      var id = el.getAttribute("data-bundle"), r = el.querySelector("[role=radio]");
      if (r) r.addEventListener("click", function () { state.selected = id; render(); });
      el.addEventListener("change", render);
    });
    var link = root.querySelector("[data-single-link]");
    if (link) link.addEventListener("click", function () { state.selected = "single"; render(); });
    btn.addEventListener("click", function () {
      var v = variant(state.selected);
      if (!v) return;
      btn.disabled = true;
      T.addToCart(v.id, 1).catch(function (e) {
        err.hidden = false;
        err.textContent = (e.data && e.data.description) || S.addError;
      }).finally(function () { btn.disabled = false; });
    });
    render();
  }

  /* ---------- Sticky bar ---------- */
  function initSticky() {
    var bar = document.querySelector("[data-sticky-bar]"), offer = document.getElementById("offer");
    if (!bar || !offer || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es) {
      var e = es[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle("is-visible", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
      bar.querySelectorAll("a,button").forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }).observe(offer);
  }

  /* ---------- Snap carousel dots ---------- */
  function initSnap(root) {
    var track = root.querySelector(".snap"), dots = root.querySelectorAll(".dots button");
    if (!track || !dots.length) return;
    function mark() {
      var first = track.children[0]; if (!first) return;
      var i = Math.round(track.scrollLeft / (first.offsetWidth + 16));
      dots.forEach(function (d, j) { d.setAttribute("aria-current", i === j ? "true" : "false"); });
    }
    track.addEventListener("scroll", function () { requestAnimationFrame(mark); }, { passive: true });
    dots.forEach(function (d, j) {
      d.addEventListener("click", function () {
        var c = track.children[j];
        if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft - 16, behavior: "smooth" });
      });
    });
    mark();
  }

  /* ---------- Read more ---------- */
  function initReadMore() {
    document.querySelectorAll("[data-read-more]").forEach(function (b) {
      var t = b.previousElementSibling;
      if (t && t.scrollHeight <= t.clientHeight + 2) { b.hidden = true; return; }
      b.addEventListener("click", function () {
        var open = t.classList.toggle("clamp-3") === false;
        b.textContent = open ? b.getAttribute("data-less") : b.getAttribute("data-more");
      });
    });
  }

  /* ---------- Videos ---------- */
  function initVideos(root) {
    var track = root.querySelector(".videos__track");
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll(".video-card"));
    var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    var wide = matchMedia("(min-width: 1024px)");
    var onScreen = false, active = 0, paused = {};
    var dots = root.querySelectorAll(".dots button");
    cards.forEach(function (c) { var v = c.querySelector("video"); v.muted = true; v.volume = 0; });

    function sync() {
      cards.forEach(function (c, i) {
        var v = c.querySelector("video"), btn = c.querySelector(".video-card__play");
        var should = onScreen && !reduce && !paused[i] && (wide.matches || i === active);
        c.classList.toggle("is-active", wide.matches || i === active);
        if (should) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        if (btn) btn.hidden = should;
      });
      dots.forEach(function (d, j) { d.setAttribute("aria-current", j === active ? "true" : "false"); });
    }
    function centre(i) {
      var c = cards[i]; if (!c) return;
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: "smooth" });
    }
    track.addEventListener("scroll", function () {
      if (wide.matches) return;
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, d = Infinity;
      cards.forEach(function (c, i) { var x = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (x < d) { d = x; best = i; } });
      if (best !== active) { active = best; paused = {}; sync(); }
    }, { passive: true });
    cards.forEach(function (c, i) {
      c.addEventListener("click", function () {
        if (!wide.matches && i !== active) { centre(i); return; }
        paused[i] = !paused[i] && !c.querySelector("video").paused ? true : false;
        if (reduce) { var v = c.querySelector("video"); v.paused ? v.play() : v.pause(); return; }
        sync();
      });
    });
    dots.forEach(function (d, j) { d.addEventListener("click", function () { centre(j); }); });
    var pv = root.querySelector(".videos__arrow--prev"), nx = root.querySelector(".videos__arrow--next");
    if (pv) pv.addEventListener("click", function () { centre(Math.max(active - 1, 0)); });
    if (nx) nx.addEventListener("click", function () { centre(Math.min(active + 1, cards.length - 1)); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(root);
    }
    wide.addEventListener && wide.addEventListener("change", sync);
  }

  /* ---------- Cart drawer custom element ---------- */
  if (!customElements.get("cart-drawer")) {
    customElements.define("cart-drawer", class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.panel = this.querySelector(".drawer__panel");
        this.addEventListener("click", function (e) {
          var t = e.target.closest("[data-close]"); if (t) { self.close(); return; }
          var q = e.target.closest("[data-qty]");
          if (q) { self.change(q.getAttribute("data-key"), +q.getAttribute("data-qty")); return; }
          var u = e.target.closest("[data-upgrade]"); if (u) self.upgrade(u);
          var c = e.target.closest("[data-choose-set]");
          if (c) { self.close(); setTimeout(function () { var o = document.getElementById("offer"); if (o) o.scrollIntoView({ behavior: "smooth" }); else location.href = R.root; }, 220); }
        });
        this.addEventListener("keydown", function (e) {
          if (e.key === "Escape") self.close();
          if (e.key === "Tab") self.trap(e);
        });
        document.querySelectorAll("[data-cart-toggle]").forEach(function (b) {
          b.addEventListener("click", function (e) { e.preventDefault(); self.open(); });
        });
      }
      trap(e) {
        var f = this.panel.querySelectorAll('a[href],button:not([disabled]),select,input,[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      open() {
        this.lastFocus = document.activeElement;
        this.classList.add("is-open"); this.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("scroll-lock");
        var self = this;
        this.render().then(function () { var c = self.querySelector("[data-close-btn]"); if (c) c.focus(); });
      }
      close() {
        this.classList.remove("is-open"); this.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("scroll-lock");
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }
      render() {
        var self = this, id = this.getAttribute("data-section-id");
        return fetch(R.root.replace(/\/$/, "") + "/?sections=" + id)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var doc = new DOMParser().parseFromString(d[id], "text/html");
            var fresh = doc.querySelector(".drawer__panel");
            if (fresh) self.panel.innerHTML = fresh.innerHTML;
          });
      }
      change(key, qty) {
        var self = this;
        this.panel.setAttribute("aria-busy", "true");
        return T.cart.change(key, Math.max(qty, 0))
          .catch(showCartError)
          .finally(function () { self.panel.removeAttribute("aria-busy"); });
      }
      upgrade(btn) {
        var self = this, box = btn.closest("[data-upgrade-box]");
        var data = JSON.parse(box.querySelector("[data-upgrade-json]").textContent);
        var err = box.querySelector("[data-upgrade-error]");
        btn.disabled = true;
        T.addBracelets(Array.prototype.map.call(box.querySelectorAll("select"), function (s) { return s.value; }))
          .catch(function (e) { err.hidden = false; err.textContent = e.message; btn.disabled = false; });
      }
    });
  }

  function init() {
    initReveal();
    document.querySelectorAll("[data-gallery]").forEach(initGallery);
    document.querySelectorAll("[data-offer]").forEach(initOffer);
    document.querySelectorAll("[data-snap]").forEach(initSnap);
    document.querySelectorAll("[data-videos]").forEach(initVideos);
    initSticky();
    initReadMore();
  }
  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-cart-page] [data-qty]");
    if (!q) return;
    e.preventDefault();
    T.cart.change(q.getAttribute("data-key"), +q.getAttribute("data-qty")).catch(showCartError);
  });
  function showCartError(error) {
    document.querySelectorAll("[data-cart-error]").forEach(function (el) { el.hidden = false; el.textContent = error.message; });
  }
  document.addEventListener("submit", function (e) {
    if (!e.target.closest("cart-drawer, [data-cart-page]") || !e.submitter || e.submitter.name !== "checkout") return;
    e.preventDefault();
    T.normalizeCart().then(function () {
      var form = document.createElement("form"); form.method = "post"; form.action = R.cart;
      var input = document.createElement("input"); input.type = "hidden"; input.name = "checkout"; input.value = "Checkout";
      form.appendChild(input); document.body.appendChild(form); form.submit();
    }).catch(showCartError);
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { T.normalizeCart().catch(showCartError); });
  else T.normalizeCart().catch(showCartError);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
